/**
 * VERSIONE LIBRERIA 3
 */

var ValidationRules = Class.extend({
    form: null,
    init: function (form) {
    	this.form = form;
    },
    get : function (rule_string) {
    	log.warn("metodo da implementare");
    	return {};
    }
});

var Vrequired = ValidationRules.extend({
	get : function (key,rule_string) {
		var self = this;
		return { required : true};

/*		
		
		
		var rules = {};
		rules[key] = { required : true};
		self.form.validate({
			rules: rules
		});
		*/
	}
});

var Vbetween =  ValidationRules.extend({
	get : function (key,rule_string) {
		var tmp = rule_string.split(":");
		var range = tmp[1].split(",");
		return {
			minlength : range[0],
			maxlength : range[1]
		};
		/*
		// rule_string between:min,max
		var self = this;
		var tmp = rule_string.split(":");
		var range = tmp[1].split(",");
		self.obj.attr('minlength',range[0].trim());
		self.obj.attr('maxlength',range[1].trim());
		*/
	}
});
/*
var Valpha_num = ValidationRules.extend({
	get : function (key,rule_string) {
		//var self = this;
		//self.obj.attr('required','');
	}
});
*/
var Vemail = ValidationRules.extend({
	get : function (key,rule_string) {
		return {email:true};
	}
});

var Vconfirmed = ValidationRules.extend({
	get : function (key,rule_string) {
		//return {};
		return { equalTo : 'input[name="'+key + '_confirmation"]'};
		/*
		var self = this;
		self.obj.attr('equalto',self.obj.attr("name") + "_confirmation");
		*/
	}
});

var Vsometimes = ValidationRules.extend({
	get : function(key,other_rules) {
		var self = this;
		var _env = {
				key : key,
				other_rules : other_rules,
				form : self.form,
		};
		return {sometimes : _env}
	}

})
if (jQuery.validator) {
	jQuery.validator.addMethod("sometimes", function(fake, element,data) {
		//console.log(data);
		$(element).rules('remove', 'sometimes');
		if ( !$(element).val())
			return true;
		for (var i in data.other_rules) {
			var rule = data.other_rules[i];
			var rule_name = rule.split(":").length > 0?rule.split(":")[0]:rule;
			rule_name = 'V'+rule_name;
			if ( !window[rule_name] )
				continue;
			var r = new window[rule_name](data.form);
			$(element).rules('add',r.get(data.key,rule));
			
		}
		var validator = data.form.validate();
		var result = validator.element( $(element) );
		var msg = validator.errorList.length?validator.errorList[0]['message']:"undefined error";
		for (var r in $(element).rules()) {
			$(element).rules('remove', r);
		}
		$(element).rules('add',{sometimes:data});
		$(element).rules('add',{messages : {sometimes:msg}});
		return result;
		
	}, "mesaggio dinamico");
}